/**
 * Scrolls to the given element using animations.
 * 
 * @param element   The element to scroll to.
 */
export function scrollTo(element: HTMLElement) {
  $('html, body').animate({
    scrollTop: $(element).offset().top + 'px',
  });
}
